import { render, staticRenderFns } from "./EstimatesOldPageTabs.vue?vue&type=template&id=fe49645a&"
import script from "./EstimatesOldPageTabs.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldPageTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports